import React from 'react';
import { Box, Text, TextButton, TextProps } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials-standalone';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { MARKETPLACE_URL } from '@utils/constants';

interface Props {
  textSize?: TextProps['size'];
  className?: string;
}

const MyProjectsLink = ({ textSize, className }: Props) => {
  const { host } = useProfileContext();

  return (
    <Box className={className} textAlign="center" align="center" width="100%">
      <Trans i18nKey="marketplace.profile-page.contact-form.submit-success-modal.view-project-requests">
        <Text size={textSize}>
          0
          <TextButton
            as="a"
            href={`${host}${MARKETPLACE_URL}my-projects`}
            target="_blank"
            underline="always"
            size={textSize}
          >
            1
          </TextButton>
        </Text>
      </Trans>
    </Box>
  );
};

export default MyProjectsLink;
